<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between">
          <h3>
            PESTEL / ماتریس جذابیت
          </h3>
          <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

        </div>
        <hr class="mb-3">
        <div class="d-flex flex-column">
          <table class="table "  v-if="all_items.length">
            <thead>
            <tr>
              <th rowspan="2">ردیف</th>
              <th rowspan="2">شاخص ها</th>
              <th rowspan="2">ضریب اهمیت</th>
              <th rowspan="2">نسبت وزنی</th>
              <th colspan="2">ميزان جذابيت (تهديد يا فرصت)</th>
            </tr>
            <tr>


              <th>نمره</th>
              <th>امتیاز</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in all_items">
              <td>{{index+1}}</td>
              <td>{{item.type}}</td>
              <td>{{item.avg_importance_factor}}</td>
              <td>{{item.avg_weight_ratio}}</td>
              <td>{{item.avg_score_attractiveness}}</td>
              <td>{{item.avg_points_attractiveness}}</td>

            </tr>
            <tr>
              <td style="background-color: #3742FA; color: #fff !important" colspan="2">
                مجموع
              </td>
              <td>{{ sumOfPoints('avg_importance_factor') }}</td>
              <td>{{ sumOfPoints('avg_weight_ratio') }}</td>
              <td  style="background-color: #3742FA; color: #fff !important">مجموع امتیازها</td>
              <td>{{ sumOfPoints('avg_points_attractiveness') }}</td>
            </tr>
            </tbody>
          </table>
          <center v-else>
            موردی یافت نشد
          </center>

          <hr class="mt-2">




        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data() {
    return {
      all_items: []
    }
  },
  methods: {
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    sumOfPoints(prop) {
      return this.all_items.reduce((total, item) => {
        // Convert item[prop] to a number and add to total, defaulting to 0 if NaN
        return total + Number(item[prop] || 0);
      }, 0);
    },

    all() {
      fetch(`${this.base_url}/PestelVariables/matrices_efe`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({}),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.all){
              this.all_items = [...response.all]
            }


          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small, span {
  font-size: 1vw !important;
}
</style>